import { render, staticRenderFns } from "./icon-logout.vue?vue&type=template&id=79d95b75"
import script from "./icon-logout.vue?vue&type=script&lang=js"
export * from "./icon-logout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports